import { API, Competition, CompetitionAPI, PageModel } from '@brg/api';
import { STATUSES } from '_competition/const';
import { useEffect, useState } from 'react';

interface RequestProps {
    id: string;
    projectsFilter: number;
    ignoredContexts?: string[]
}

export const useCompetitionsByTag = ({ id, projectsFilter, ignoredContexts }: RequestProps , date: number, lang: string, callback?: (n: number) => void,disable?: boolean) => {
    const [data, setData] = useState<PageModel<Competition<'Local'>>>();

    const fetch = (id: string, projectFilter: number | undefined) => {
        //@ts-ignore
        CompetitionAPI.GetList({ 
            byTagIds: [id], 
            initTags: true, 
            ...(ignoredContexts && { ignoredContexts }), 
            ...(projectsFilter && { competitionStatus: projectsFilter }) })
        .then((r) => r.json())
        .then((r) => {
            setData({
                ...r,
                data: API.toLang(r.data, lang),
            })
            callback && callback(r?.data?.length)
        })
    } 

    useEffect(() => {
        if (!disable) {
            fetch(id, projectsFilter)
        }
    } , [id, disable, projectsFilter, date])

    return data;
}import { API, Competition, CompetitionAPI, PageModel } from '@brg/api';
import { STATUSES } from '_competition/const';
import { useEffect, useState } from 'react';

interface RequestProps {
    id: string;
    projectsFilter: number;
    ignoredContexts?: string[]
}

export const useCompetitionsByTag = ({ id, projectsFilter, ignoredContexts }: RequestProps , date: number, lang: string, callback?: (n: number) => void,disable?: boolean) => {
    const [data, setData] = useState<PageModel<Competition<'Local'>>>();

    const fetch = (id: string, projectFilter: number | undefined) => {
        //@ts-ignore
        CompetitionAPI.GetList({ 
            byTagIds: [id], 
            initTags: true, 
            ...(ignoredContexts && { ignoredContexts }), 
            ...(projectsFilter && { competitionStatus: projectsFilter }) })
        .then((r) => r.json())
        .then((r) => {
            setData({
                ...r,
                data: API.toLang(r.data, lang),
            })
            callback && callback(r?.data?.length)
        })
    } 

    useEffect(() => {
        if (!disable) {
            fetch(id, projectsFilter)
        }
    } , [id, disable, projectsFilter, date])

    return data;
}